import {Tag, Tooltip} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {PiWarningCircleFill} from 'react-icons/pi'

export const EstimatedDobTag = ({className = "text-orange-400"}) => {
    const t = useTranslate()
    return (
        <Tooltip title={t('estimated date of birth tooltip')}>
            <PiWarningCircleFill size={16} className={`cursor-pointer ${className}`}/>
        </Tooltip>
    )
}
